import { render, staticRenderFns } from "./JobsearchApplicationDetail.vue?vue&type=template&id=87b413be&scoped=true&"
import script from "./JobsearchApplicationDetail.vue?vue&type=script&lang=ts&"
export * from "./JobsearchApplicationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./JobsearchApplicationDetail.vue?vue&type=style&index=0&id=87b413be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b413be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VSimpleTable,VSpacer})
